import React from 'react';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';

export const AddButton = ({ to, label, onClick }) => {
    return (
        <>
            {to ? (
                <Link to={to} style={{ textDecoration: 'none' }}>
                    <Button
                        sx={{
                            backgroundColor: 'primary.main',
                            color: 'white',
                            textAlign: 'center',
                            fontSize: '14px',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            padding: 3,
                            paddingY: 1,
                            borderRadius: '0.25rem',
                            '&:hover': {
                                backgroundColor: '#114797',
                            },
                        }}
                    >
                        {label}
                    </Button>
                </Link>
            ) : (
                <Button
                    onClick={onClick}
                    sx={{
                        backgroundColor: 'primary.main',
                        color: 'white',
                        textAlign: 'center',
                        fontSize: '14px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        padding: 3,
                        paddingY: 1,
                        borderRadius: '0.25rem',
                        '&:hover': {
                            backgroundColor: '#114797',
                        },
                    }}
                >
                    {label}
                </Button>
            )}
        </>
    );
};
